import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import './Dialog.css';
import React from 'react';
import FocusableButton from 'components/common/FocusableButton';

export default function Dialog(props) {
  const {
    id,
    reference, // no use
    placement, // 'screen-center'
    connection, // 'none'
    width, // integer | 'auto'
    height, // integer | 'auto'
    veilable, // no use
    stickable, // no use
    movable, // true
    closable, // Boolean
    escapable, // Boolean
    modal, // true
    dim, // color (default=transparent)
    tags = [], // optional
    type,
    title, // no use
    description, // no use
    contents, // no use
    buttons = [], // no use
    events = {}, // required
    props: {
      children,
      ...propsRest
    },
    ...rest
  } = props || {};

  React.useEffect(() => {
    events.onMount && events.onMount(props);
    return () => {
      events.onUnmount && events.onUnmount(props);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const ref = React.useRef();

  const [currentIndex, setCurrentIndex] = React.useState(0);
  const [count, setCount] = React.useState(() => React.Children.count(children));
  const onNext = React.useCallback(() => {
    setCurrentIndex((index) => Math.max(0, Math.min(count - 1, index + 1)));
  }, [count]);
  const onPrev = React.useCallback(() => {
    setCurrentIndex((index) => Math.max(0, Math.min(count - 1, index - 1)));
  }, [count]);
  return (
    <div
      {...ex('Dim')}
    >
      <div
        {...ex(['DialogContainer', placement, ...tags], rest)}
        {...{ ref }}
      >
        {React.Children.map(children, (child, index) => {
          if (index !== currentIndex) return null;
          return React.cloneElement(child, {
            ...propsRest,
            events,
            index,
            count,
            onNext,
            onPrev,
          });
        })}
      </div >
    </div>
  );
}
